<script setup="">
import { computed } from "vue";

import { convertToComma, convertToHumanize } from "@/utilities/number";

const props = defineProps({
  value: {
    type: [String, Number],
    required: true
  },
  humanize: {
    type: Boolean,
    required: false,
    default: false
  }
});

const number = computed(() => {
  if (props.humanize) {
    return convertToHumanize(props.value ? Number(props.value) : 0);
  } else {
    return convertToComma(props.value ? Number(props.value) : 0);
  }
});
</script>

<template>
  <span><span v-text="number"></span> <slot /></span>
</template>
